import { css } from 'styled-components';

// Temporary restyling to match prod until we update blog + account layouts
// Turns off the grid at the root and resets some max-width and padding to the original non-grid size
export default css`
    #layout-selector {
        display: block;

        > .rh-pcb {
            > * {
                max-width: 1380px;
                padding-left: min(7%, 90px);
                padding-right: min(7%, 90px);
            }
        }
    }
`;
